import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../styles/js/mixins';
import {spacing} from '../../styles/js/variables';
import {ContainerSizes} from '../../styles/js/variables/elementSizing';

const styles = {
  termsModal: (shouldShowMore: boolean): string => css`
    label: termsModal;
    margin: -${spacing.XS};
    padding: ${spacing.S} 0;

    > p {
      margin-top: ${spacing.XS};
      margin-bottom: ${spacing.XS};
    }

    ${mq(Breakpoints.TABLET)} {
      margin: 0;
      padding: ${spacing.S};
    }

    ${shouldShowMore &&
    `
        > p {
        max-width: ${ContainerSizes.SM};
        margin-right: 0;
        margin-left: 0;
    }
      `}
  `,
  termsModalLogo: css`
    label: termsModalLogo;
    width: auto;
    height: 4rem;
    vertical-align: middle;
  `,
};

export default styles;
